// The server answers a successful return with the label PDF as a file body,
// and a failure with a redirect back to the form. The old code could not tell
// those apart from a plain form post, so it set a cookie server-side and
// polled document.cookie once a second to know when to move on. Reading the
// response directly removes both the cookie and the poll.
export async function submitReturn(form, { thankYouPath }) {
  const response = await fetch(form.action, {
    method: "POST",
    body: new FormData(form),
    credentials: "same-origin",
    headers: { Accept: "application/pdf, text/html" },
  });

  const type = response.headers.get("content-type") || "";

  if (type.includes("pdf")) {
    const blob = await response.blob();
    downloadBlob(blob, "Retourenschein-Versandaufkleber.pdf");
    window.location.assign(thankYouPath);
    return { ok: true };
  }

  // Anything else means the shipment was rejected; the server has already put
  // the reason in the flash, so re-render the page it sends back.
  window.location.assign(response.url || form.action);
  return { ok: false };
}

function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Revoke late: Safari needs the object alive until the download starts.
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
